import React from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import ReferralOptions from '../ReferralsIndexContainer/ReferralOptions';

function ReferralTrigger({
  csrfToken,
  referralPath,
  newReferralPath,
  authCodeUrl,
  shareOnLinkedinUrl,
  returnFromLinkedIn,
  authStatus,
  isConsultant,
  location,
  referredUserType,
}) {
  return (
    <ModalTrigger
      triggerText="Refer Now"
      buttonStyles="primary"
      idKey={`refer-trigger-modal-${location.replace(/\s/g, '')}`}
      showFooter={false}
      biggerButton
    >
      <ReferralOptions
        csrfToken={csrfToken}
        referralPath={referralPath}
        newReferralPath={newReferralPath}
        authCodeUrl={authCodeUrl}
        shareOnLinkedinUrl={shareOnLinkedinUrl}
        returnFromLinkedIn={returnFromLinkedIn}
        authStatus={authStatus}
        isConsultant={isConsultant}
        addReferrals={() => {}}
        location={location}
        referredUserType={referredUserType}
      />
    </ModalTrigger>
  );
}

ReferralTrigger.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  referralPath: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  returnFromLinkedIn: PropTypes.bool,
  shareOnLinkedinUrl: PropTypes.string.isRequired,
  authCodeUrl: PropTypes.string,
  authStatus: PropTypes.number,
  isConsultant: PropTypes.bool,
  location: PropTypes.string.isRequired,
  referredUserType: PropTypes.string.isRequired,
};

ReferralTrigger.defaultProps = {
  returnFromLinkedIn: false,
  authCodeUrl: null,
  authStatus: null,
  isConsultant: false,
};

export default ReferralTrigger;
